export const setIsContactScanDataPresent = (state, action) => {
  state.isContactScanDataPresent = action.payload;
};

export const setContactScanData = (state, action) => {
  state.contactScanData = action.payload;
};

export const setApolloContactsData = (state, action) => {
  state.apolloContactsData = action.payload;
};

export const setApolloDropdownData = (state, action) => {
  state.apolloDropdownData = action.payload;
};
